import React from 'react'
import * as Logos from '../images/logos/index'
import { shuffle } from '../utilities'

const allCustomers = Object.entries(Logos).map(([key, value]) => ({
    name: key,
    logo: value,
}));

export default class FavoriteRelationships extends React.Component {
    state = { displayCustomers: [], fadeOut: false };

    componentDidMount = () => {
        this.updateCustomers();

        if (this.props.customers.length > 5) {
            const intervalId = setInterval(this.updateDisplay, 10000);
            this.setState({ intervalId })
        }
    };

    updateDisplay = () => {
        this.setState({ fadeOut: true });

        const timeoutId = setTimeout(this.updateCustomers, 2000);
        this.setState({ timeoutId })
    };

    updateCustomers = () => {
        const { customers } = this.props;

        const eligibleCustomers = allCustomers.filter(c =>
            customers.includes(c.name)
        );

        const displayCustomers = shuffle(eligibleCustomers).slice(0, 5);

        this.setState({
            displayCustomers: displayCustomers,
            fadeOut: false,
        })
    };

    componentWillUnmount = () => {
        clearInterval(this.state.intervalId);
        clearTimeout(this.state.timeoutId)
    };

    render() {
        const customerList = this.state.displayCustomers.map(customer => {
            const Logo = customer.logo;

            return (
                <Logo
                    className={`logo fade-in ${
                        this.state.fadeOut ? 'fade-out' : ''
                    }`}
                    key={Math.random()} // React will not rerender the logo and the animation won't happen if the key is the same from one transistion to the next, so we need to make sure its random.
                />
            )
        });

        return (
            <div
                className={`col-12 favorite_relationships container ${this.props.productHint}`}
            >
                <div className="favorite_relationships page_header">
                    A few of our relationships
                </div>
                {/* HOLD FOR V2
                <Link to="/reviews">
                    View our Reviews <div className="arrow" />
                </Link> */}
                <div className="logos">
                    <div className="row">{customerList}</div>
                </div>
            </div>
        )
    }
}
